import React from "react";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/auth-context";

function LogoutButton({ onLogout }) {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuth()


  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, log out",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsAuthenticated(false)
        localStorage.removeItem('isAuthenticated')
        // Clear all local and local storage data
        localStorage.clear();
        localStorage.clear();

        // Ensure redirection without back navigation
        navigate("/login", { replace: true });

        // Reload to fully reset local
        window.location.reload();
      }
    });
  };

  return (
    <IconButton
      color="inherit"
      onClick={handleLogout}
      title="Logout"
      sx={{
        bgcolor: '#5b9be4ff',
        '&:hover': { bgcolor: '#ffccd5' },
        borderRadius: 2,
      }}
    >
      <LogoutIcon sx={{ color: '#0a0606ff', fontSize: 30 }} />
    </IconButton>

  );
}

export default LogoutButton;
